export { default } from './HomeOutlineTwo'
